import {createGoogleTagManagerScript} from './createGoogleTagManagerScript';
import {isGoogleTagManagerEnabled} from './isGoogleTagManagerEnabled';

export function GoogleTagManagerHead() {
  if (!isGoogleTagManagerEnabled()) {
    return null;
  }

  const googleTagManagerId =
    (import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID as string | undefined)
      ?.trim() ?? '';

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: createGoogleTagManagerScript(googleTagManagerId),
      }}
    />
  );
}
